import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUnpinPostMutation = createMutationHook(MembershipsCreatorApiClient.unpinPost, {
  mutationKey: ['unpinPost'],
})
